export default __webpack_public_path__ + "static/Artificial_Light_Indoor-b9a15b92f4ca68f0857d37abdc0222e1.avif";